import ChildrenCategoriesTypeEnum from 'Rentlio/utils/childrenCategoriesEnum'

// all custom children prices go here
export function getTotalChildrenPrice(basePrice, { children }, { childrenDifferentThanAdults, childrenCategories }) {
  if (!childrenDifferentThanAdults) {
    return 0
  }

  let childrenPrice = 0

  children.map(age =>
    childrenCategories.map(category => {
      if (age >= category.ageFrom && age < category.ageTo) {
        if (category.type === ChildrenCategoriesTypeEnum.CUSTOM && category.percentageValue > 0) {
          childrenPrice += (basePrice * category.percentageValue) / 100
        }
      }
    })
  )

  return childrenPrice
}
